import React from "react";
import * as Icon from "react-feather";

import "./statement-workspace-modal.css";

import UtilityService from "../../../../services/UtilityService";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import ToolsDocumentPane from "../kit/ToolsDocumentPane";
import StatementReadingPanel from "./StatementReadingPanel";

class StatementWorkspaceModal extends WComponent {
	renderTheDocument = () => {
		const { statement } = this.props;

		return (
			<ToolsDocumentPane
				withOpenLink
				documentId={statement.documentId}
				title={statement.fileName || "Bank statement"}
				nothingOnFileMessage="No copy of this statement was kept, so there is nothing to read it against."
			/>
		);
	};

	renderTheDifference = () => {
		const { shortfall } = this.props;
		if (!shortfall || shortfall.shortBy === null || shortfall.shortBy === undefined) return null;

		const difference = UtilityService.formatSignedCurrency({ value: Math.abs(shortfall.shortBy) });
		const theStatementMovesMore = shortfall.shortBy > 0;

		return (
			<div className="sw-modal__difference">
				<Icon.AlertTriangle size={15} />
				<span>
					{theStatementMovesMore ? (
						<>
							This statement moves <strong>{difference}</strong> more than the transactions booked from it. Something printed on it was never
							read into the books.
						</>
					) : (
						<>
							The transactions booked from this statement move <strong>{difference}</strong> more than the statement does. Something is in the
							books that this statement does not show.
						</>
					)}
				</span>
			</div>
		);
	};

	render() {
		const { statement, shortfall, wpfEngagementId, isSignedOff, onReadingChanged, onClose } = this.props;

		const period = UtilityService.describeDateRange({ start: statement.periodStart, end: statement.periodEnd });

		const footer = (
			<>
				<span className="sw-modal__footer-note">
					Corrections change what this statement is recorded as saying. Anything already in the books is only changed when you say so.
				</span>
				<span className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>
						Done
					</button>
				</span>
			</>
		);

		return (
			<ToolsModal open={true} onClose={onClose} title={statement.fileName || "Bank statement"} width={1180} footer={footer}>
				<p className="sw-modal__period">
					{statement.accountLabel || statement.bankName || "Account not read"} · {period}
				</p>
				{this.renderTheDifference()}
				<div className="sw-modal__panes">
					<div className="sw-modal__pane sw-modal__pane--document">{this.renderTheDocument()}</div>
					<div className="sw-modal__pane sw-modal__pane--lines">
						<StatementReadingPanel
							statementId={statement.id}
							wpfEngagementId={wpfEngagementId}
							shortfall={shortfall}
							isSignedOff={isSignedOff}
							onReadingChanged={onReadingChanged}
						/>
					</div>
				</div>
			</ToolsModal>
		);
	}
}

export default StatementWorkspaceModal;
